/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { AEM_URL } from '../../config';
import { IFarmlandsFooterViewProps } from './farmlands-footer';
// @ts-ignore
import { CommonFooter } from '@farmlands/common-components';
import MsDyn365 from '@msdyn365-commerce/core';

export default (props: IFarmlandsFooterViewProps) => {
    const { actionResponse } = props;

    if (!MsDyn365.isBrowser) {
        return null;
    }

    return (
        <CommonFooter
            {...actionResponse}
            AEM_URL={AEM_URL}
        />
    );
};
